// src/components/AccidentTypesSection.jsx
import React from "react";
import s81 from "./s81.svg";
import s82 from "./s82.svg";
import s83 from "./s83.svg";
import s84 from "./s84.svg";
import s85 from "./s85.svg";
import s86 from "./s86.svg";
import s87 from "./s87.svg";
import s88 from "./s88.svg";

/**
 * SectionEight
 * - Responsive grid: 1 / 2 / 4 columns (mobile / tablet / desktop)
 * - Uses local SVG files (s81–s88.svg)
 * - Fully accessible + pixel-matched layout
 */
export default function SectionEight() {
  const items = [
    {
      id: 1,
      title: "Rear-End Accidents",
      desc: "Common cause of whiplash and soft tissue damage.",
      icon: s81,
    },
    {
      id: 2,
      title: "Head-On Collisions",
      desc: "Often result in severe or fatal injuries.",
      icon: s82,
    },
    {
      id: 3,
      title: "Hit-And-Run Accidents",
      desc: "Require investigation and legal follow-up.",
      icon: s83,
    },
    {
      id: 4,
      title: "Intersection Accidents",
      desc: "Frequently involve right-of-way disputes.",
      icon: s84,
    },
    {
      id: 5,
      title: "Multi-Vehicle Accidents",
      desc: "Complex fault and multiple claims.",
      icon: s85,
    },
    {
      id: 6,
      title: "Rollover Accidents",
      desc: "Often lead to spinal injuries or fractured sternums.",
      icon: s86,
    },
    {
      id: 7,
      title: "Sideswipe Accidents",
      desc: "May appear minor but cause frame or internal injuries.",
      icon: s87,
    },
    {
      id: 8,
      title: "T-Bone Accidents",
      desc: "Common at intersections, often result in rib or head trauma.",
      icon: s88,
    },
  ];

  return (
    <section className="bg-white py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-3xl md:text-4xl font-extrabold text-red-700 mb-12">
          Types of Car Accidents We Handle
        </h2>

        {/* Responsive grid: 1 / 2 / 4 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((it) => (
            <article
              key={it.id}
              className="bg-white rounded-2xl p-8 shadow-[0_18px_40px_rgba(15,23,42,0.06)] flex flex-col items-center text-center"
              aria-labelledby={`card-${it.id}-title`}
            >
              <div className="text-red-700">
                <img
                  src={it.icon}
                  alt=""
                  aria-hidden
                  className="w-20 h-20 mx-auto object-contain"
                />
              </div>

              <h3
                id={`card-${it.id}-title`}
                className="mt-5 text-base md:text-lg font-semibold text-gray-800"
              >
                {it.title}
              </h3>

              <p className="mt-3 text-sm text-gray-600 leading-6">
                {it.desc}
              </p>
            </article>
          ))}
        </div>

        {/* CTA button centered */}
        <div className="mt-12 flex justify-center">
          <button
            type="button"
            className="px-8 py-3 bg-red-700 text-white rounded-lg font-semibold shadow-md hover:-translate-y-1 transform transition"
            onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
          >
            Get My Free Lawsuit Case Review
          </button>
        </div>
      </div>
    </section>
  );
}
